export default {
  label: "configurator",
};
